export default "__VITE_ASSET__BhUbTcVJ__"